// extracted by mini-css-extract-plugin
export default {"myBtn":"Input_myBtn__k-LEJ"};